import { useEffect } from "react";

import Header from "@/components/layout/Header";
import Hero from "@/components/modules/home/Hero";
import Explore from "@/components/Explore/Explore";
import About from "@/components/About";
import Menu from "@/components/Menu/Menu";
import OpeningHours from "@/components/OpeningHours";
import Testimonials from "@/components/Testimonials";
import Footer from "@/components/Footer";

export default function Index() {
  useEffect(() => {
    const loadLocomotiveScroll = async () => {
      // Dynamic import: loads the module only when needed (lazy loading)
      const LocomotiveScroll = (await import("locomotive-scroll")).default;

      // Initialize Locomotive Scroll instance
      // It automatically detects elements with data-scroll attributes
      new LocomotiveScroll();
    };

    loadLocomotiveScroll();
  }, []); // Empty array means this effect runs only once on mount

  return (
    <div className="flex flex-col min-h-screen">
      <main className="grow">
        <Header />
        <Hero />
        <Explore />
        <About />
        <Menu />
        <OpeningHours />
        <Testimonials />
      </main>
      <Footer />
    </div>
  );
}
